import { render, staticRenderFns } from "./ListTurnoDetalle.vue?vue&type=template&id=5395bf72&"
import script from "./ListTurnoDetalle.vue?vue&type=script&lang=js&"
export * from "./ListTurnoDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports